export const DRAFT_CAPITAL_2026 = {
  "Fernando Mendoza": { pick: 1, round: 1, pos: "QB" },
  "Jeremiyah Love": { pick: 3, round: 1, pos: "RB" },
  "Carnell Tate": { pick: 4, round: 1, pos: "WR" },
  "Jordyn Tyson": { pick: 8, round: 1, pos: "WR" },
  "Ty Simpson": { pick: 13, round: 1, pos: "QB" },
  "Kenyon Sadiq": { pick: 16, round: 1, pos: "TE" },
  "Makai Lemon": { pick: 20, round: 1, pos: "WR" },
  "KC Concepcion": { pick: 24, round: 1, pos: "WR" },
  "Omar Cooper": { pick: 30, round: 1, pos: "WR" },
  "Jadarian Price": { pick: 32, round: 1, pos: "RB" },
  "De'Zhaun Stribling": { pick: 33, round: 2, pos: "WR" },
  "Denzel Boston": { pick: 39, round: 2, pos: "WR" },
  "Germie Bernard": { pick: 47, round: 2, pos: "WR" },
  "Eli Stowers": { pick: 54, round: 2, pos: "TE" },
  "Nate Boerkircher": { pick: 56, round: 2, pos: "TE" },
  "Marlin Klein": { pick: 59, round: 2, pos: "TE" },
  "Max Klare": { pick: 61, round: 2, pos: "TE" },
  "Carson Beck": { pick: 65, round: 3, pos: "QB" },
  "Sam Roush": { pick: 69, round: 3, pos: "TE" },
  "Antonio Williams": { pick: 71, round: 3, pos: "WR" },
  "Oscar Delp": { pick: 73, round: 3, pos: "TE" },
  "Malachi Fields": { pick: 74, round: 3, pos: "WR" },
  "Caleb Douglas": { pick: 75, round: 3, pos: "WR" },
  "Drew Allar": { pick: 76, round: 3, pos: "QB" },
  "Zachariah Branch": { pick: 79, round: 3, pos: "WR" },
  "Ja'Kobi Lane": { pick: 80, round: 3, pos: "WR" },
  "Chris Brazzell": { pick: 83, round: 3, pos: "WR" },
  "Ted Hurst": { pick: 84, round: 3, pos: "WR" },
  "Will Kacmarek": { pick: 87, round: 3, pos: "TE" },
  "Zavion Thomas": { pick: 89, round: 3, pos: "WR" },
  "Kaelon Black": { pick: 90, round: 3, pos: "RB" },
  "Chris Bell": { pick: 94, round: 3, pos: "WR" },
  "Eli Raridon": { pick: 95, round: 3, pos: "TE" },
  "Brenen Thompson": { pick: 105, round: 4, pos: "WR" },
  "Jonah Coleman": { pick: 108, round: 4, pos: "RB" },
  "Cade Klubnik": { pick: 110, round: 4, pos: "QB" },
  "Elijah Sarratt": { pick: 115, round: 4, pos: "WR" },
  "Kaden Wetjen": { pick: 121, round: 4, pos: "WR" },
  "Mike Washington": { pick: 122, round: 4, pos: "RB" },
  "Skyler Bell": { pick: 125, round: 4, pos: "WR" },
  "Matthew Hibner": { pick: 133, round: 4, pos: "TE" },
  "Bryce Lance": { pick: 136, round: 4, pos: "WR" },
  "Colbie Young": { pick: 140, round: 4, pos: "WR" },
  "Reggie Virgil": { pick: 143, round: 5, pos: "WR" },
  "Justin Joly": { pick: 152, round: 5, pos: "TE" },
  "Emmett Johnson": { pick: 161, round: 5, pos: "RB" },
  "Tanner Koziol": { pick: 164, round: 5, pos: "TE" },
  "Nicholas Singleton": { pick: 165, round: 5, pos: "RB" },
  "Kendrick Law": { pick: 168, round: 5, pos: "WR" },
  "Riley Nowakowski": { pick: 169, round: 5, pos: "TE" },
  "Joe Royer": { pick: 170, round: 5, pos: "TE" },
  "Josh Cuevas": { pick: 173, round: 5, pos: "TE" },
  "Adam Randall": { pick: 174, round: 5, pos: "RB" },
  "Cyrus Allen": { pick: 176, round: 5, pos: "WR" },
  "Kevin Coleman": { pick: 177, round: 5, pos: "WR" },
  "Cole Payton": { pick: 178, round: 5, pos: "QB" },
  "Seydou Traore": { pick: 180, round: 5, pos: "TE" },
  "Taylen Green": { pick: 182, round: 6, pos: "QB" },
  "Bauer Sharp": { pick: 185, round: 6, pos: "TE" },
  "Kaytron Allen": { pick: 187, round: 6, pos: "RB" },
  "Barion Brown": { pick: 190, round: 6, pos: "WR" },
  "Josh Cameron": { pick: 191, round: 6, pos: "WR" },
  "Malik Benson": { pick: 195, round: 6, pos: "WR" },
  "CJ Daniels": { pick: 197, round: 6, pos: "WR" },
  "Demond Claiborne": { pick: 198, round: 6, pos: "RB" },
  "Emmanuel Henderson": { pick: 199, round: 6, pos: "WR" },
  "CJ Williams": { pick: 203, round: 6, pos: "WR" },
  "Lewis Bond": { pick: 204, round: 6, pos: "WR" },
  "Anthony Smith": { pick: 218, round: 7, pos: "WR" },
  "Jack Endries": { pick: 221, round: 7, pos: "TE" },
  "Athan Kaliakmanis": { pick: 223, round: 7, pos: "QB" },
  "Jaren Kanak": { pick: 225, round: 7, pos: "TE" },
  "Eli Heidenreich": { pick: 230, round: 7, pos: "RB" },
  "Behren Morton": { pick: 234, round: 7, pos: "QB" },
  "Seth McGowan": { pick: 237, round: 7, pos: "RB" },
  "Jam Miller": { pick: 245, round: 7, pos: "RB" },
  "Carsen Ryan": { pick: 248, round: 7, pos: "TE" },
  "Garrett Nussmeier": { pick: 249, round: 7, pos: "QB" },
  "Deion Burks": { pick: 254, round: 7, pos: "WR" },
  "Dallen Bentley": { pick: 256, round: 7, pos: "TE" },
};
